import {
  ADD_TO_WISHLIST_TYPE,
  FETCH_WISHLIST_TYPE,
  REMOVE_FROM_WISHLIST_TYPE,
} from '../actions';

const initialState = {
  skus: {},
};

const asyncActionReducer = (state, action, type) => {
  switch (action.type) {
    case `${type}_PENDING`:
      return {
        ...state,
        busy: true,
      };
    case `${type}_FULFILLED`:
      return {
        ...state,
        busy: false,
        error: undefined,
        skus: action.payload,
      };
    case `${type}_REJECTED`:
      return {
        ...state,
        busy: false,
        error: action.payload,
      };
    default:
      return undefined;
  }
};

const asyncActionsReducer = (state, action) => {
  const singleReducer = type => asyncActionReducer(state, action, type);
  return (
    singleReducer(FETCH_WISHLIST_TYPE)
    || singleReducer(ADD_TO_WISHLIST_TYPE)
    || singleReducer(REMOVE_FROM_WISHLIST_TYPE)
  );
};

const wishlist = (state = initialState, action) => (
  asyncActionsReducer(state, action)
  || state
);

export default wishlist;
